<template>
  <div class="DatePickerTimeMinutes">
    <div class="minute" v-for="minute in minutes" @click="selectMinute(minute)">
      {{ padStart(minute, 2, '0') }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { padStart } from "./utility.js";

let props = defineProps([
  "date"
]);

let emit = defineEmits([
  "selectedMinute"
]);

let minutes = computed(() => {
  return [ 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55 ];
});

function selectMinute(minute) {
  emit("selectedMinute", minute);
}
</script>

<style scoped>
.DatePickerTimeMinutes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.minute {
  padding: 20px;
  text-align: center;
}
.minute:hover {
  border-radius: 10px;
  background: var(--gray-200);
}
</style>